import { SlimHeader } from '@/components/SlimHeader';
import { useCurrentUserContext } from '@/contexts/CurrentUserContext';
import { printVisibility } from '@/features/styles/lib/printStyles';
import { BreadCrumbs } from './BreadCrumbs';
import { HeaderNav } from './HeaderNav';
import { useIsExperiencePage } from './useIsExperiencePage';
import { useIsHeaderNavVisible } from './useIsHeaderNavVisible';

type Props = {
  actions?: JSX.Element;
  variant?: 'default' | 'magic';
};

export const AppHeader = ({ actions, variant = 'default' }: Props) => {
  const onGradient = variant === 'magic';
  const { isAuthenticated } = useCurrentUserContext();
  const isExperiencePage = useIsExperiencePage();
  const isNavVisible = useIsHeaderNavVisible();

  return (
    <SlimHeader
      bg={onGradient ? 'transparent' : 'white'}
      borderBottomColor="line.DEFAULT"
      borderBottomWidth={onGradient ? 0 : '1px'}
      color="ink.strong"
      h={isExperiencePage ? 'ah-nav' : 'ah-nav-lg'}
      logoHeight={{ base: 20, md: 28 }}
      logoHref={isAuthenticated ? { to: '/' } : { to: '/', external: true }}
      logoVariant="pink"
      pos={onGradient ? 'relative' : undefined}
      rightColumn={actions}
      showBrandText={onGradient}
      sx={printVisibility.hide()}
      zIndex={onGradient ? 1 : undefined}
      containerProps={{
        maxW: '100%',
        px: { base: 4, md: 7 },
        gap: { base: 3, md: 10 },
        gridTemplateColumns: 'minmax(0, 1fr) auto',
      }}
      leftExtra={
        isNavVisible || isExperiencePage ? (
          <>
            <HeaderNav />
            {isExperiencePage && <BreadCrumbs />}
          </>
        ) : undefined
      }
    />
  );
};
